import './App.css'
import Layout from './components/main';

function App() {
  return (
      <Layout />
  )
}
export default App;
